import { useSnapshot } from 'valtio';

import { authState } from '../../../../services/state/auth-state.jsx';
import { CATALYST_USER_ROLES } from '../../../../utils/constants.js';

import Logo from '../../../../assets/img/mar-shopping.png';

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from '../../../ui/sidebar.jsx';
import { sidebarData } from './_data.js';
import { NavGroup } from './nav-group.jsx';
import { NavUser } from './nav-user.jsx';

export function AppSidebar({ ...props }) {
  const { user } = useSnapshot(authState);

  return (
    <Sidebar collapsible="icon" variant="floating" {...props}>
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
            >
              <div className="flex aspect-square size-7 items-center justify-center rounded-lg">
                <img src={Logo} className="h-full w-full" alt="Logo" />
              </div>
              <div className="grid flex-1 text-left leading-tight">
                <p className="truncate text-sm font-semibold">MAR SHOPPING</p>
                <p className="truncate text-xs">Gestão de Campanhas</p>
              </div>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        {sidebarData.navGroups.map((props) => {
          const isAdmin = user?.details?.role === CATALYST_USER_ROLES.admin;

          if (props.title === 'Admin' && !isAdmin) {
            return null;
          }

          return <NavGroup key={props.title} {...props} />;
        })}
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
